import React, { Component } from "react";
import logomotion from "../MyFiles/SalcoLogoMotion.mp4";

class Welcome extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <video
            onEnded={() => this.props.handleVideoEnded()}
            autoPlay
            playsInline
            muted
          >
            <source src={logomotion} type="video/mp4"></source>
          </video>
        </header>
      </div>
    );
  }
}

export default Welcome;
